export class ToolsValidations {
  public static passRequirement = {
    passwordMinLowerCase: 1,
    passwordMinNumber: 1,
    passwordMinSymbol: 0,
    passwordMinUpperCase: 1,
    passwordMinCharacters: 8,
  };

  public static patternUser = ['^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ]+$']
    .map((item) => item.toString())
    .join('');

  public static patternMail = ['[a-z0-9._%+-]+@[a-z0-9.-]+[.].[a-z]{1,4}$']
    .map((item) => item.toString())
    .join('');

  // public static patternMailv2 = ['/^\S/[a-z0-9._%+-]+@[a-z0-9.-]+[.][a-z]{1,4}/^\S/']
  public static patternMailv2 = ['^[a-z0-9._%+-]+@[a-z0-9.-]+[.][a-z]{1,4}$']
    .map((item) => item.toString())
    .join('');

  public static recoveryEmail = ['[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{1,4}']
    .map((item) => item.toString())
    .join('');

  public static trimValidator = ['^S.*S$|^S$']
    .map((item) => item.toString())
    .join('');

  public static patternUserFullName = ['^[A-Za-z ñÑáéíóúÁÉÍÓÚ]+[^s]$']
    .map((item) => item.toString())
    .join('');
  public static patternUserFullNameComplete = ['^[A-Za-z ñÑáéíóúÁÉÍÓÚ–‘]+$']
    .map((item) => item.toString())
    .join('');

  public static patternPassword = [
    `(?=([^a-z]*[a-z])\{${this.passRequirement.passwordMinLowerCase},\})`,
    `(?=([^A-Z]*[A-Z])\{${this.passRequirement.passwordMinUpperCase},\})`,
    `(?=([^0-9]*[0-9])\{${this.passRequirement.passwordMinNumber},\})`,
    `[A-Za-z\\d]{${this.passRequirement.passwordMinCharacters},}`,
  ]
    .map((item) => item.toString())
    .join('');

  public static patternLowerCase = [
    `(?=([^a-z]*[a-z])\{${this.passRequirement.passwordMinLowerCase},\})`,
  ]
    .map((item) => item.toString())
    .join('');

  public static patternUpperCase = [
    `(?=([^A-Z]*[A-Z])\{${this.passRequirement.passwordMinLowerCase},\})`,
  ]
    .map((item) => item.toString())
    .join('');

  public static patternNumber = [
    `(?=([^0-9]*[0-9])\{${this.passRequirement.passwordMinLowerCase},\})`,
  ]
    .map((item) => item.toString())
    .join('');

  public static patternNoSpaces = ['[[:space:]]']
    .map((item) => item.toString())
    .join('');

  // public static patternCaracterEspecial = [`(?=([^[[:punct:]]]*[[[:punct:]]])\{${this.passRequirement.passwordMinLowerCase},\})`]
  public static patternCaracterEspecial = [
    '^[!"#$%&\'()*+,-./:;<=>?@[]^_{|}]{1}+$',
  ]
    .map((item) => item.toString())
    .join('');
  public static patternNumberCustom = [`^\\d{6,12}$`]
    .map((item) => item.toString())
    .join('');
  public static patternContactName = ["^[A-Za-z ñÑáéíóúÁÉÍÓÚ.']+$"]
    .map((item) => item.toString())
    .join('');
    public static patternNumber8digits = [`^\\d{8,12}$`]
    .map((item) => item.toString())
    .join('');
}
